import { useLoggedInQuery } from '@/src/common/gql/MesaGql'
import {
  GET_CARD_ORDER_INFORMATION,
  GET_CREDIT_CARD_INFORMATION,
} from '@/src/common/gql/queries/card'
import { useLogError } from '@/src/common/hooks/useLogError'
import { CardDeliveryBarSkeleton } from './Skeleton'
import { CardDeliveryStatus } from '@/src/common/components/CardDeliveryStatus'
import { DesignSystem } from '@/src/design-system'

export function CardDeliveryBarHighnote() {
  const onError = useLogError()
  const {
    data: cardOrderData,
    loading: loadingCardOrderData,
    refetch: refetchCardOrderInformation,
  } = useLoggedInQuery(GET_CARD_ORDER_INFORMATION, { fetchPolicy: 'cache-and-network', onError })
  const {
    data: creditCardInformation,
    loading: loadingCreditCardInformation,
    refetch: refetchCreditCardInformation,
  } = useLoggedInQuery(GET_CREDIT_CARD_INFORMATION, { fetchPolicy: 'cache-and-network', onError })

  DesignSystem.ScreenWideReload.useReloadListener(async () => {
    await refetchCardOrderInformation()
    await refetchCreditCardInformation()
  })

  const hasPhysicalCardToActivate =
    creditCardInformation?.getCreditCardInformation.node?.virtualCardIdForPhysicalCard
  const cardOrderStatus = cardOrderData?.getCardOrderInformation.node?.status
  const cardOrderStatusInDisplayableStatus =
    cardOrderStatus === 'SUBMITTED' ||
    cardOrderStatus === 'PRINTED' ||
    cardOrderStatus === 'SHIPPED'

  if (loadingCardOrderData || loadingCreditCardInformation) {
    return <CardDeliveryBarSkeleton />
  }

  if (hasPhysicalCardToActivate && cardOrderStatusInDisplayableStatus) {
    return (
      <CardDeliveryStatus
        trackingNumber={cardOrderData?.getCardOrderInformation.node?.trackingNumber}
        status={cardOrderStatus}
      />
    )
  }

  return null
}
